import { useId } from "react";


export function MicGlyph({ className }: { className?: string }) {
  // React's useId contains colons, which are hostile inside url(#...).
  const gradientId = `wake-orb-mic-${useId().replace(/:/g, "")}`;

  return (
    <svg
      className={className}
      viewBox="0 0 32.5013 35.6897"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M27.0188 11.9386L27.4014 11.0609C28.0834 9.49573 29.3118 8.2496 30.8446 7.56788L32.0233 7.04362C32.6607 6.76013 32.6607 5.83264 32.0233 5.54915L30.9105 5.05418C29.3383 4.35493 28.0879 3.06268 27.4176 1.44439L27.0247 0.495828C26.751 -0.165276 25.8379 -0.165276 25.5641 0.495828L25.1712 1.44439C24.501 3.06268 23.2506 4.35493 21.6784 5.05418L20.5655 5.54915C19.9282 5.83264 19.9282 6.76013 20.5655 7.04362L21.7443 7.56788C23.2771 8.2496 24.5055 9.49573 25.1874 11.0609L25.5699 11.9386C25.85 12.5813 26.7389 12.5813 27.0188 11.9386ZM0 17.069H3.12821C3.88116 22.3329 8.40817 26.3793 13.8803 26.3793C19.3523 26.3793 23.8793 22.3329 24.6324 17.069H27.7605C27.045 23.5421 21.9052 28.6819 15.4321 29.3976V35.6897H12.3286V29.3976C5.85535 28.6819 0.715578 23.5421 0 17.069ZM13.8807 1.55172C9.59569 1.55172 6.12203 5.02538 6.12203 9.31034V15.5172C6.12203 19.8022 9.59569 23.2759 13.8807 23.2759C18.1656 23.2759 21.6393 19.8022 21.6393 15.5172V10.8621H18.5358V15.5172C18.5358 18.0883 16.4517 20.1724 13.8807 20.1724C11.3096 20.1724 9.22548 18.0883 9.22548 15.5172V9.31034C9.22548 6.73937 11.3096 4.65517 13.8807 4.65517C14.8073 4.65517 15.6665 4.92438 16.3898 5.38833L18.0655 2.77619C16.8572 2.00106 15.419 1.55172 13.8807 1.55172Z"
        fill={`url(#${gradientId})`}
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="16.2507"
          y1="0"
          x2="16.2507"
          y2="35.6897"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#B0E6EA" />
        </linearGradient>
      </defs>
    </svg>
  );
}
